<div class="d-flex row align-items-baseline ">
    <div class="col-md-6 form-group" >
        <form *ngIf="showSearch">
            <div class="relative">
                <input [ngStyle]="{ 'border': fromSms ? '1px solid grey': '' }" class="form-control search" [formControl]="searchField" maxlength="200"  placeholder="{{ placeholder || 'Search'}}">
                <div class="absolute" >
                    <img *ngIf="!searchText.length" src="../../../../../assets/images/search.svg" width="14px" height="14px"/>
                    <img *ngIf="searchText.length" src="../../../../../assets/images/Cancel.svg" (click)="resetSearch()" width="14px" height="14px" />
                </div>
            </div>
        </form>
    </div>
    <div class="col-md-6 text-end filter-data">
        <ng-content></ng-content>
    </div>

</div>